<template>
	<nk-wrapper v-if="context.mitarbeiter" spacing="md">
		<section>
			<nk-title tag="h1" size="3xl">
				{{ context.mitarbeiter.vorname }}
				{{ context.mitarbeiter.nachname }}
			</nk-title>

			<nk-list variant="clean">
				<nk-list-item
					v-for="(amt, indexAemter) in context.mitarbeiter.aemter"
					:key="`indexAemter${indexAemter}`"
				>
					{{ amt.funktion }}
				</nk-list-item>
			</nk-list>

			<nk-wrapper v-if="context.mitarbeiter.aufgabenfelder" spacing="lg">
				<nk-title tag="h2" size="xl">Aufgabenbereich</nk-title>
				<div
					class="nk-cms-content"
					v-html="context.mitarbeiter.aufgabenfelder"
				/>
			</nk-wrapper>

			<nk-wrapper spacing="lg">
				<nk-image
					v-if="context.mitarbeiter.bild"
					class="w-48 sm:w-72 sm:ml-4 sm:float-right"
					:src="context.mitarbeiter.bild"
					:alt="context.mitarbeiter.bildtext"
					:copyright="context.mitarbeiter.bildcopyright"
					:caption="context.mitarbeiter.bildtext"
					:lightbox="
						options.bildvergroesserung != null
							? options.bildvergroesserung
							: false
					"
					image-class="w-full"
				/>
				<div class="grid grid-cols-1 md:grid-cols-2 gap-4">
					<div v-if="context.mitarbeiter.kontakt || context.mitarbeiter.zimmer">
						<nk-title tag="h2" size="xl">Anschrift</nk-title>
						<nk-address
							variant="vertical"
							v-bind="{
								...context.mitarbeiter.kontakt,
								...context.mitarbeiter.aemter[0].adresse,
							}"
							:zimmer="context.mitarbeiter.zimmer"
						/>
					</div>
					<div v-if="context.mitarbeiter.sprechzeiten">
						<nk-title tag="h2" size="xl">Sprechzeiten</nk-title>
						<div
							class="nk-cms-content"
							v-html="context.mitarbeiter.sprechzeiten"
						/>
					</div>
				</div>

				<!-- servicebw_verfahren[] auslesen -->
				<template
					v-if="
						context.mitarbeiter.servicebw_verfahren != null &&
						context.mitarbeiter.servicebw_verfahren.length > 0
					"
				>
					<nk-divider spacing="lg" class="clear-both" />

					<nk-title :id="`title-${titleId}`" tag="h2" size="xl">
						Zuständigkeiten
					</nk-title>
					<nk-nav variant="links" :aria-labelledby="`title-${titleId}`">
						<nk-nav-item
							v-for="(verfahren, index) in context.mitarbeiter
								.servicebw_verfahren"
							:key="`verfahren-${index}`"
							:link="verfahren.detailURL"
						>
							{{ verfahren.titel }}
						</nk-nav-item>
					</nk-nav>
				</template>
			</nk-wrapper>

			<nk-divider spacing="lg" class="clear-both" />

			<nk-title :id="`title-${titleId}`" tag="h2" size="xl">
				In folgenden Ämterbereichen bin ich für Sie tätig:
			</nk-title>

			<nk-nav variant="links" :aria-labelledby="`title-${titleId}`">
				<nk-nav-item
					v-for="(amt, index) in context.mitarbeiter.aemter"
					:key="`amt-${index}`"
					:link="amt.detailURL"
				>
					{{ amt.titel }}
				</nk-nav-item>
			</nk-nav>
		</section>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';
import {useId} from '#imports';

/**
 * @prop {object} context.mitarbeiter
 */
export default {
	name: 'NkTemplateMitarbeiterDetail',

	mixins: [TemplatesDefault],

	setup() {
		const titleId = useId();
		return {titleId};
	},
};
</script>
